import { NgModule } from '@angular/core';
import { ConfirmModule } from './confirm/confirm.module';
import { SimpleModalModule } from './simple/simple.module';
import { ListInfoModule } from './list-info/list-info.module';
import { TrReceiptModule } from './tr-receipt/tr-receipt.module';
import { GenericErrorModule } from './generic-error/generic-error.module';
import { DialogReceiptModule } from './dialog-receipt/dialog-receipt.module';
import { OverlaySimpleModule } from './overlay-simple/overlay-simple.module';
import { ConfirmWithOptionsModule } from './cards/confirm-with-options/confirm-with-options.module';
import { ForgotPasswordEmailSuccessfullySentModule } from './forgot-password-email-successfully-sent/forgot-password-email-successfully-sent.module';
import { PiNewPasswordEmailSuccessfullySentModule } from './pi-new-password-email-successfully-sent/pi-new-password-email-successfully-sent.module';
import { BrokerageZeroModule } from "./brokerage-zero/brokerage-zero.module";
import { RewardsModule } from './rewards/rewards.module';

/**
 * All Dialogs
 */
@NgModule({
    imports: [
        ConfirmModule,
        SimpleModalModule,
        ListInfoModule,
        TrReceiptModule,
        GenericErrorModule,
        OverlaySimpleModule,
        DialogReceiptModule,
        ConfirmWithOptionsModule,
        ForgotPasswordEmailSuccessfullySentModule,
        PiNewPasswordEmailSuccessfullySentModule,
        BrokerageZeroModule,
        RewardsModule,
    ],
})
export class DialogsModule {}
